export class BiActiveState {

    static ACTIVE = "ACTIVE";
    static INACTIVE = "INACTIVE";
}